//import { permissionCheck } from "./permission-check";
export const buildClasses = (navigation, strings,permissions,onClick) => {
  let baseUrl = navigation.region
    ? `/areas/${navigation.area.id}/regions/${navigation.region.id}`
    : `/areas/${navigation.area.id}/regions/na`;
  baseUrl = navigation.coordinator
    ? `${baseUrl}/coordinators/${navigation.coordinator.id}/programs/${navigation.program.id}`
    : `${baseUrl}/coordinators/na/programs/${navigation.program.id}`;

  baseUrl = `${baseUrl}/years/${navigation.year.id}/terms/${navigation.term.id}`;

  const item = {
    id:10,
    type: "link",
    label: strings.classes,
    "data-id": "accordion-classes",
    href: `${baseUrl}/classes`,
    onClick:(e) => {
      onClick({
        event:e,
        href: `${baseUrl}/classes`,
      });
    }
  };
  return item;
};
